import { render, staticRenderFns } from "./KoalaPaySuccess.vue?vue&type=template&id=cff54ac2&"
import script from "./KoalaPaySuccess.vue?vue&type=script&lang=js&"
export * from "./KoalaPaySuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports